import state from './moduleTimekeepingState.js'
import mutations from './moduleTimekeepingMutations.js'
import actions from './moduleTimekeepingActions.js'
import getters from './moduleTimekeepingGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}